// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"f079b75b","394":"7585fbd8","443":"b8a7f218","453":"64b8b932","485":"85da9d10","571":"8910eb6b","610":"1675ad1d","636":"9631a81b","691":"33f0a0cf","804":"391bf1e4","888":"61a00d8f","934":"9b6a5ed7"}[chunkId] + ".chunk.js";
};